/**
 * Serialize a version string
 * Example: "1.2.3" => "1000002000003000000000000000000000000000"
 * @param version
 * @returns
 */
function serializeVersion(version: string) {
  return version
    .split(".")
    .map((part: string) => part.padStart(6, "0"))
    .join()
    .padEnd(40, "0");
}

/**
 * Compare 2 versions and return:
 *   -1 if version1 < version2
 *   0 if version1 = version2
 *   +1 if version 1 > version2
 * @param version1
 * @param version2
 * @returns
 */
export function versionCompare(version1: string, version2: string) {
  const _version1 = serializeVersion(version1);
  const _version2 = serializeVersion(version2);
  return _version1 === _version2 ? 0 : _version1 < _version2 ? -1 : 1;
}
